'use strict';
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver from "./com.raquo.airstream.common.-Internal-Try-Observer.js";
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal from "./com.raquo.airstream.common.-Single-Parent-Signal.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dError$002dHandling$002dError from "./com.raquo.airstream.core.-Airstream-Error$-Error-Handling-Error.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal from "./com.raquo.airstream.core.-Writable-Signal.js";
import * as $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dSignal from "./com.raquo.airstream.distinct.-Distinct-Signal.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
import * as $j_scala$002eutil$002e$002dFailure from "./scala.util.-Failure.js";
import * as $j_scala$002eutil$002e$002dSuccess from "./scala.util.-Success.js";
import * as $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024 from "./scala.util.control.-Non-Fatal$.js";
var $p;
function $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__($thiz, parent, project, recover) {
  $thiz.rF = parent;
  $thiz.rG = project;
  $thiz.rH = recover;
  $thiz.uR = (void 0);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V($thiz);
  $thiz.rC = 0;
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V($thiz);
  $thiz.rE = (void 0);
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V($thiz);
  $thiz.uU = ((1 + parent.dT()) | 0);
  return $thiz;
}
export { $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__ as $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__ };
/** @constructor */
function $c_Lcom_raquo_airstream_misc_MapSignal() {
  this.uR = null;
  this.uQ = false;
  this.uS = null;
  this.rC = 0;
  this.uO = null;
  this.uP = null;
  this.uV = false;
  this.rE = null;
  this.uT = false;
  this.rD = 0;
  this.rF = null;
  this.rG = null;
  this.rH = null;
  this.uU = 0;
}
export { $c_Lcom_raquo_airstream_misc_MapSignal as $c_Lcom_raquo_airstream_misc_MapSignal };
$p = $c_Lcom_raquo_airstream_misc_MapSignal.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_misc_MapSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_MapSignal() {
}
export { $h_Lcom_raquo_airstream_misc_MapSignal as $h_Lcom_raquo_airstream_misc_MapSignal };
$h_Lcom_raquo_airstream_misc_MapSignal.prototype = $p;
$p.dP = (function() {
  return this.uR;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.gA = (function() {
  return this.uQ;
});
$p.fm = (function() {
  return this.uS;
});
$p.ea = (function(x$1) {
  this.uQ = x$1;
});
$p.gD = (function(x$1) {
  this.uS = x$1;
});
$p.f = (function(obj) {
  return (this === obj);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this);
});
$p.gs = (function() {
  return this.rC;
});
$p.kI = (function(x$1) {
  this.rC = x$1;
});
$p.hm = (function(observer) {
  observer.fY(this.b3());
});
$p.ew = (function() {
  return this.uO;
});
$p.ey = (function() {
  return this.uP;
});
$p.hw = (function() {
  return this.uV;
});
$p.g1 = (function(x$1) {
  this.uV = x$1;
});
$p.hf = (function(x$0) {
  this.uO = x$0;
});
$p.hg = (function(x$0) {
  this.uP = x$0;
});
$p.l3 = (function() {
  return this.rE;
});
$p.rb = (function(x$1) {
  this.rE = x$1;
});
$p.b3 = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.fW = (function(nextValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.fV = (function(nextError, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.rc = (function() {
  return this.uT;
});
$p.tQ = (function() {
  return this.rD;
});
$p.kJ = (function(x$1) {
  this.rD = x$1;
});
$p.u2 = (function(x$0) {
  this.uT = x$0;
});
$p.hp = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V(this);
});
$p.ll = (function(nextValue, nextParentLastUpdateId) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
$p.hn = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$p.ho = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$p.dT = (function() {
  return this.uU;
});
$p.fX = (function(nextParentValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  nextParentValue.eT(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError) => {
    var this$2 = this.rH;
    if (this$2.k()) {
      $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
    } else {
      var x0 = this$2.C();
      try {
        var $x_1 = new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(x0.cr(nextError, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => null))));
      } catch (e) {
        var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
        matchResult1: {
          var $x_1;
          var x2 = $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024.$m_s_util_control_NonFatal$().ht(e$2);
          if ((!x2.k())) {
            var $x_1 = new $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure(x2.C());
            break matchResult1;
          }
          throw ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? e$2.aZ : e$2);
        }
      }
      $x_1.eT(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError$3$3) => ((tryError) => {
        $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dError$002dHandling$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError(tryError, nextError$3$3), transaction);
      }))(nextError)), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError$3$4) => ((nextValue) => {
        if ((nextValue === null)) {
          $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError$3$4, transaction);
        } else if ((!nextValue.k())) {
          $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue.C(), transaction);
        }
      }))(nextError)));
    }
  })), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue.ra(this.rG), transaction);
  })));
});
$p.id = (function() {
  var originalValue = this.rF.b3().ra(this.rG);
  return originalValue.eT(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError) => {
    var this$2 = this.rH;
    if (this$2.k()) {
      return originalValue;
    } else {
      var x0 = this$2.C();
      try {
        var $x_1 = new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(x0.cr(nextError, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => null))));
      } catch (e) {
        var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
        matchResult1: {
          var $x_1;
          var x2 = $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024.$m_s_util_control_NonFatal$().ht(e$2);
          if ((!x2.k())) {
            var $x_1 = new $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure(x2.C());
            break matchResult1;
          }
          throw ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? e$2.aZ : e$2);
        }
      }
      return $x_1.eT(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError$7$3) => ((tryError) => new $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dError$002dHandling$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError(tryError, nextError$7$3))))(nextError)), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue) => {
        if ((nextValue === null)) {
          return originalValue;
        } else {
          var this$10 = (nextValue.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some(new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(nextValue.C())));
          return (this$10.k() ? originalValue : this$10.C());
        }
      })));
    }
  })), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => originalValue)));
});
$p.eB = (function() {
  return this.rF;
});
$p.hi = (function(isSame) {
  return new $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dSignal.$c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dS = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_MapSignal = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_misc_MapSignal, "com.raquo.airstream.misc.MapSignal", ({
  c2: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  au: 1,
  az: 1,
  as: 1,
  aQ: 1,
  aj: 1,
  ay: 1,
  b1: 1
}));
export { $d_Lcom_raquo_airstream_misc_MapSignal as $d_Lcom_raquo_airstream_misc_MapSignal };
